import { Component } from '@angular/core';
import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';
import { DxTileViewModule } from 'devextreme-angular/ui/tile-view';
import { FormItemControlService } from '../../services/form-item-control.service';
import { ImageItem } from 'src/app/models/image-item';

@Component({
  templateUrl: 'home.component.html',
  styleUrls: [ './home.component.scss' ],
providers: [DynamicFormComponent]
})

export class HomeComponent {
  public menuItems: string[];
  public selectedMenuitems: string[];
  public isLoggedIn: boolean;

  public images: ImageItem[] = [
    {
      imgsrc: './assets/Images/BanffLogo.jpeg',
      alttext: 'Logo',
      heightRatio: 6,
      widthRatio: 6
    },
    {
      imgsrc: './assets/Images/kidney1.png',
      alttext: 'Top Side Image',
      heightRatio: 2,
      widthRatio: 2
    },
    {
      imgsrc: './assets/Images/kidney2.png',
      alttext: 'Bottom Side Image',
      heightRatio: 2,
      widthRatio: 2
    },
  ];


  constructor(private formItemControlService: FormItemControlService) {
    const imgs = this.images;
    this.isLoggedIn = false;

    this.formItemControlService.getIsLoggedInObservable().subscribe(bIsLoggedIn => {
      this.isLoggedIn = bIsLoggedIn;
    });
  }
}
